import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './SequenceToolbar.module.css';
import { DATE_FORMAT } from '../../constants';
const SequenceToolbar = ({
  lineName,
  date,
}) => {
  return (
    <>
      <div className={styles.aggregateToolbar}>
        <div className={styles.countTitleWrapper}>
          <span aria-label="ed" className={styles.sequenceName}>
            {lineName}
          </span>
          <span className={styles.title}>Sequence</span>

          <div className={styles.dateTitle}>
            Date
            <span className={styles.date}>{moment(
                date,
                DATE_FORMAT.ISO,
              ).format(DATE_FORMAT.DD_MM_YYYY)}</span>
          </div>
        </div>
        <div className={styles.note}>
          Note: Define your preferred order for Part drop by using the “Resequence” tool provided below
        </div>
      </div>
    </>
  );
};
SequenceToolbar.propTypes = {
  lineName: PropTypes.string.isRequired,
  date: PropTypes.objectOf(moment),

};

export default SequenceToolbar;
